import React from 'react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';

/**
 * Cookie Policy.
 *
 * Describes only cookies the platform genuinely sets - session/auth, a few
 * preferences, and analytics. Deliberately does NOT promise an in-product cookie
 * preferences panel, because there isn't one; browser controls are the honest
 * answer until we build it.
 */
const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen">
      <Header />

      <main className="pt-24 pb-16">
        <section className="section">
          <div className="max-w-3xl mx-auto">
            <h1 className="heading-1 mb-4">Cookie Policy</h1>
            <p className="text-[#83928c] mb-8">Last updated: September 2026</p>

            <div className="prose prose-lg max-w-none">
              <div className="space-y-8">
                <div>
                  <h2 className="heading-3 mb-4">What Cookies Are</h2>
                  <p className="text-[#83928c]">
                    Cookies are small text files stored on your device when you visit a website. They
                    let a site recognise your browser between requests — which is how you stay signed
                    in as you move from one page to the next. This policy covers cookies and similar
                    storage used by Tenses, operated by TALENTSCALE INDIA PRIVATE LIMITED.
                  </p>
                </div>

                <div>
                  <h2 className="heading-3 mb-4">How We Use Cookies</h2>
                  <p className="text-[#83928c] mb-4">
                    We use cookies for a small number of specific purposes:
                  </p>
                  <ul className="list-disc list-inside text-[#83928c] space-y-2">
                    <li>
                      <strong className="text-[#1a1a2e]">Essential cookies</strong> — keep you signed
                      in, maintain your session as you move between modules, and protect against
                      fraudulent or automated requests. The platform cannot work without these.
                    </li>
                    <li>
                      <strong className="text-[#1a1a2e]">Preference cookies</strong> — remember
                      choices such as your display settings so you do not have to set them again.
                    </li>
                    <li>
                      <strong className="text-[#1a1a2e]">Analytics cookies</strong> — tell us, in
                      aggregate, which pages are used and where people run into trouble, so we can
                      improve the product. These do not tell us who you are.
                    </li>
                  </ul>
                  <p className="text-[#83928c] mt-4">
                    We do not use cookies for advertising, and we do not sell the information they
                    collect.
                  </p>
                </div>

                <div>
                  <h2 className="heading-3 mb-4">How Long They Last</h2>
                  <div className="space-y-4">
                    <div className="bg-[#f8f9fa] rounded-lg p-4">
                      <h4 className="font-medium text-[#1a1a2e] mb-1">Session cookies</h4>
                      <p className="text-sm text-[#83928c]">
                        Temporary, and cleared when you close your browser. Used to hold your signed-in
                        session while you practise.
                      </p>
                    </div>
                    <div className="bg-[#f8f9fa] rounded-lg p-4">
                      <h4 className="font-medium text-[#1a1a2e] mb-1">Persistent cookies</h4>
                      <p className="text-sm text-[#83928c]">
                        Stay on your device for a set period so you are not asked to sign in again
                        every visit, and so your preferences are remembered.
                      </p>
                    </div>
                    <div className="bg-[#f8f9fa] rounded-lg p-4">
                      <h4 className="font-medium text-[#1a1a2e] mb-1">Third-party cookies</h4>
                      <p className="text-sm text-[#83928c]">
                        Set by services we rely on — our payment gateway during checkout, and our
                        analytics provider. These are governed by those providers&apos; own privacy
                        policies.
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <h2 className="heading-3 mb-4">Our Mobile App</h2>
                  <p className="text-[#83928c]">
                    The mobile app does not use browser cookies. It stores your session token
                    securely on your device to keep you signed in, and clears it when you sign out.
                  </p>
                </div>

                <div>
                  <h2 className="heading-3 mb-4">Managing Cookies</h2>
                  <p className="text-[#83928c] mb-4">
                    Every major browser lets you view, block or delete cookies through its settings,
                    and mobile devices have their own controls for limiting tracking. Clearing site
                    data for Tenses will remove the cookies we have set.
                  </p>
                  <p className="text-[#83928c]">
                    Please note that blocking essential cookies will sign you out and prevent the
                    platform from working — you will not be able to stay logged in or record your
                    progress.
                  </p>
                </div>

                <div>
                  <h2 className="heading-3 mb-4">Updates to This Policy</h2>
                  <p className="text-[#83928c]">
                    We may update this Cookie Policy as the platform changes. The revision date at the
                    top of this page always reflects the current version.
                  </p>
                </div>

                <div>
                  <h2 className="heading-3 mb-4">Contact Us</h2>
                  <p className="text-[#83928c]">
                    Questions about our use of cookies can be sent to privacy@tenses.ai or through our
                    Contact page.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CookiePolicyPage;
